"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = DeleteOutline;

var _DeleteOutline = require("@adobe/react-spectrum-workflow/dist/DeleteOutline");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function DeleteOutline(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_DeleteOutline.A4uDeleteOutline, null));
}